import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { AutoAwesome, WarningAmber } from '@mui/icons-material';
import { tokens } from '../../theme';

export default function FastingRecommendationsPanel({ recommendations, onApplyProtocol }) {
  if (!recommendations?.suggestedProtocol) return null;

  const { suggestedProtocol, confidence, reasons, nudges, cautions, insights } = recommendations;

  return (
    <Box
      sx={{
        mt: 1.2,
        p: 1.35,
        border: '1px solid rgba(197, 215, 152, 0.16)',
        backgroundColor: 'rgba(255,255,255,0.02)',
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
        <AutoAwesome sx={{ color: tokens.accentStrong, fontSize: 18 }} />
        <Typography variant="subtitle2" sx={{ color: tokens.cream, fontWeight: 700 }}>
          Suggested protocol
        </Typography>
        <Chip
          size="small"
          label={suggestedProtocol}
          onClick={onApplyProtocol ? () => onApplyProtocol(suggestedProtocol) : undefined}
          sx={{ cursor: onApplyProtocol ? 'pointer' : 'default' }}
        />
        <Chip size="small" variant="outlined" label={`${Math.round((confidence || 0) * 100)}% fit`} />
      </Stack>

      {reasons?.length > 0 && (
        <Typography variant="caption" sx={{ color: tokens.textSoft, display: 'block', mb: 0.75 }}>
          {reasons[0]}
        </Typography>
      )}

      {nudges?.[0] && (
        <Typography variant="caption" sx={{ color: tokens.accentStrong, display: 'block', mb: 0.75 }}>
          {nudges[0].message}
        </Typography>
      )}

      {insights?.completionRate != null && (
        <Typography variant="caption" sx={{ color: tokens.textMuted }}>
          {Math.round(insights.completionRate * 100)}% completion over the last {insights.lookbackDays || 14} days
        </Typography>
      )}

      {cautions?.[0] && (
        <Stack direction="row" spacing={0.75} alignItems="flex-start" sx={{ mt: 0.85 }}>
          <WarningAmber sx={{ color: '#e2b35f', fontSize: 16, mt: 0.1 }} />
          <Typography variant="caption" sx={{ color: tokens.textMuted }}>
            {cautions[0]}
          </Typography>
        </Stack>
      )}
    </Box>
  );
}
